<template>
  <v-container fluid fill-height>
    <v-layout wrap fill-height justify-center align-center>
      <v-flex xs12 md4>
        <v-card>
          <v-btn icon @click="$router.push({ name: 'login' })">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-card-title class="d-block text-center">
            <span class="font-weight-medium">Telefon Numarası Seçimi</span>
          </v-card-title>
          <div class="d-block text-center">
            <span class=" heading font-weight-thin">
              Oturum açmak için lütfen bir telefon numarası seçiniz.
            </span>
          </div>
          <v-card-text>
            <span
              v-if="resendResponse !== ''"
              class="subtitle-1 mt-2 primary--text"
            >
              {{ resendResponse }}
            </span>
            <v-select
              v-model="user.selected_auth_number"
              :items="items"
              type="numeric"
              label="Seçiniz..."
              item-text="phone"
              item-value="id"
            >
              <template v-slot:item="{ item }">
                <p>{{ item.phone }}</p>
                &nbsp;
                <p v-if="item.id == 0">{{ item.name }}</p>
                <p v-if="item.id != 0">({{ item.name }})</p>
              </template>
            </v-select>
          </v-card-text>
          <v-card-actions class="d-block text-right">
            <v-btn color="primary" @click="login" :disabled="loading" :loading="loading">Giriş</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Selection",
  data: () => ({
    items: [],
    resendResponse: "",
    loading: false,
    user: {
      selected_auth_number: null,
      username: null,
      password: null,
    },
  }),
  methods: {
    ...mapActions({ send: "sendBackend" }),
    login(redirectUser = null, byRedirect = false) {
      this.loading = true;
      this.send({
        route: "two/step/login/web",
        data: byRedirect ? redirectUser : this.user,
      }).then((res) => {
        const twoFA = {
          resend: res.data.data.resend_key,
          hash: res.data.data.hash,
          state: true,
          selected_auth_number: this.user.selected_auth_number,
        };
        this.$store.commit("setTwoFA", twoFA);
        this.$router.push({ name: "2fa" });
      }).finally(() => {
        this.loading = false;
      });
    },
    loaded() {
      this.items = this.$store.state.selection.numbers;
      this.user.selected_auth_number = this.items[0].phone;
      this.user.username = this.$store.state.selection.username;
      this.user.password = this.$store.state.selection.password;
    },
    log(item) {
      console.log(item);
    },
  },
  created() {
    this.loaded();
  },
};
</script>
